import { CalendarCheck2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <Link className={`brand-mark${compact ? " is-compact" : ""}`} to="/">
      <span className="brand-mark-icon" aria-hidden="true">
        <CalendarCheck2 size={22} strokeWidth={2.4} />
      </span>
      {!compact && <span>DeVerlofkaart</span>}
    </Link>
  );
}
